import { ServiceHubFaq } from '../ServiceHubForm';
import { FaqKey } from './types';

export enum ACTIVE_TAB {
  POLISH = 0,
  ENGLISH = 1,
  RUSSIAN = 2,
  UKRANIAN = 3,
}

export enum LANGUAGES {
  POLISH = 'Pl',
  ENGLISH = 'En',
  RUSSIAN = 'Ru',
  UKRANIAN = 'Uk',
}

export const chooseLangAccordingToTab = (lang: ACTIVE_TAB) => {
  const tabToLang = {
    [ACTIVE_TAB.POLISH]: LANGUAGES.POLISH,
    [ACTIVE_TAB.ENGLISH]: LANGUAGES.ENGLISH,
    [ACTIVE_TAB.RUSSIAN]: LANGUAGES.RUSSIAN,
    [ACTIVE_TAB.UKRANIAN]: LANGUAGES.UKRANIAN,
  };
  return tabToLang[lang];
};

export const isServiceHubFaqArray = (v: unknown): v is ServiceHubFaq[] => {
  return (
    Array.isArray(v) &&
    v.every(
      (x) =>
        x &&
        typeof x === 'object' &&
        typeof (x as any).q === 'string' &&
        typeof (x as any).a === 'string',
    )
  );
};

export const chooseFaqKeyAccordingToTab = (tab: ACTIVE_TAB): FaqKey => {
  const map: Record<ACTIVE_TAB, FaqKey> = {
    [ACTIVE_TAB.POLISH]: 'faqPl',
    [ACTIVE_TAB.ENGLISH]: 'faqEn',
    [ACTIVE_TAB.RUSSIAN]: 'faqRu',
    [ACTIVE_TAB.UKRANIAN]: 'faqUk',
  };
  return map[tab];
};